import { Component } from '@angular/core';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent {
  public langs = [
    {
      label: 'English',
      value: 'en'
    },
    {
      label: 'Czech',
      value: 'cz'
    }
  ];
  public selectedLang: string = 'en';
  public data = {
    en: {
      header: 'Welcome to the AI Portal',
      description: 'This portal offers three specialized applications, AI Chat, DAISE and File Chat, to enhance your productivity. See below for important information about their functioning and your rights:',
      items: [
        {
          header: 'Identification as an AI system',
          items: [
            'Be aware that while using our applications, you communicate with an artificial intelligence, not with a human.'
          ]
        },
        {
          header: 'Purpose of the application',
          items: [
            '<b>AI Chat:</b> Designated for work purposes, enter queries up to the Confidential level. Not intended for personal use.',
            '<b>DAISE:</b> Helps searching in internal documents via chat, enter queries up to the Confidential level. The answer comes with a link to the internal document where the information was taken from. Not intended to be a substitute for legal or medical advice.'
          ]
        },
        {
          header: 'Abilities and limitations',
          items: [
            'Our systems generate texts based on prompts but may contain inaccuracies and are not always up to date. We recommend verifying important information from other sources.'
          ]
        },
        {
          header: 'Security and privacy policy',
          items: [
            'Your data is processed in compliance with GDPR. They are not used to train AI models. You have the right to access your data and to their deletion.'
          ]
        },
        {
          header: 'How to interact with the applications',
          items: [
            'For efficient use, enter clear and specific questions. The system may not be used in any manner that is unlawful or harmful.'
          ]
        },
        {
          header: 'Output explanation',
          items: [
            'The answers are generated based on training data and probabilistic models and are not intended to be a substitute for professional consulting.'
          ]
        }
      ]
    },
    cz: {
      header: 'Vítejte na AI Portálu',
      description: 'Tento portál nabízí tři specializované aplikace, AI Chat, DAISE a File Chat, které slouží k podpoře vaší pracovní efektivity. Níže naleznete důležité informace o jejich fungování a vašich právech:',
      items: [
        {
          header: 'Identifikace jako AI systém',
          items: [
            'Upozorňujeme, že při používání našich aplikací komunikujete s umělou inteligencí, nikoliv s člověkem.'
          ]
        },
        {
          header: 'Účel aplikace',
          items: [
            '<b>AI Chat:</b> Určen pro pracovní účely, vložené dotazy mohou být až do úrovně Confidental. Není určený pro osobní použití.',
            '<b>DAISE:</b> Pomáhá při vyhledávání v interních dokumentech pomocí chatu, vložené  dotazy mohou být až do úrovně Confidental. U odpovědi je uveden odkaz na interní dokument, z kterého informace pochází. Není určený pro právní nebo lékařské poradenství.'
          ]
        },
        {
          header: 'Schopnosti a omezení',
          items: [
            'Naše systémy generují texty na základě vstupů, ale mohou obsahovat nepřesnosti a nejsou vždy aktuální. Doporučujeme ověřit důležité informace z jiných zdrojů.'
          ]
        },
        {
          header: 'Bezpečnost a ochrana osobních údajů',
          items: [
            'Vaše data jsou zpracovávána v souladu s GDPR. Nejsou používána k trénování AI modelů. Máte právo na přístup k vašim datům a jejich vymazání.'
          ]
        },
        {
          header: 'Způsob interakce',
          items: [
            'Pro efektivní využití zadávejte jasné a konkrétní otázky. Systém nesmí být použit pro nezákonné nebo škodlivé účely.'
          ]
        },
        {
          header: 'Vysvětlení výstupů',
          items: [
            'Odpovědi jsou generovány na základě tréninkových dat a pravděpodobnostních modelů a nemají charakter profesionálního poradenství.'
          ]
        }
      ]
    }
  };
}
